import { Components, stepConnectorClasses, Theme } from '@mui/material';

export const getMuiStepConnector = (
  theme: Theme,
): Components['MuiStepConnector'] => ({
  styleOverrides: {
    root: {
      [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line},
       &.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main,
      },
    },

    line: {
      borderWidth: 0,
      height: 2,
      backgroundColor: theme.palette.grey[100],
    },
  },
});
